import type { Dict } from '../../i18n';

const dict: Dict = {
  en: { topbar_sub: 'your account', heading: 'Profile', loading: 'Loading profile…', email: 'E-mail', role: 'Role' },
  es: { topbar_sub: 'tu cuenta', heading: 'Perfil', loading: 'Cargando perfil…', email: 'Correo electrónico', role: 'Rol' },
  de: { topbar_sub: 'Ihr Konto', heading: 'Profil', loading: 'Profil wird geladen…', email: 'E-Mail', role: 'Rolle' },
};

export default dict;
